export interface ModelPricingMetadata {
    inputPerMillionUsd?: number
    outputPerMillionUsd?: number
    cacheReadPerMillionUsd?: number
    cacheWritePerMillionUsd?: number
    tiered?: boolean
}

function normalizeModelSearch(value: string): string {
    return value
        .toLowerCase()
        .replaceAll(/[^a-z0-9]+/g, " ")
        .trim()
}

export function matchesModelSearch(query: string, values: ReadonlyArray<string | undefined>): boolean {
    const terms = normalizeModelSearch(query).split(" ").filter(Boolean)
    if (terms.length === 0) return true
    const haystack = normalizeModelSearch(values.filter(Boolean).join(" "))
    return terms.every((term) => haystack.includes(term))
}

function formatRate(rate: number): string {
    if (rate === 0) return "$0"
    if (rate >= 10) return `$${rate.toFixed(rate % 1 === 0 ? 0 : 1)}`
    return `$${rate
        .toFixed(rate < 1 ? 2 : 1)
        .replace(/0+$/, "")
        .replace(/\.$/, "")}`
}

export function formatModelPricing(pricing: ModelPricingMetadata | undefined): string | null {
    const input = pricing?.inputPerMillionUsd
    const output = pricing?.outputPerMillionUsd
    if (input === undefined || output === undefined) return null
    if (input === 0 && output === 0) return "Free"
    return `${pricing?.tiered ? "From " : ""}${formatRate(input)} in · ${formatRate(output)} out / 1M`
}
